module.exports = __webpack_public_path__ + "img/store-play-es.f9ac739.png";